var spoiler_default = {
  "fontElementMap": "XZ2Kt",
  "hideText": "B-ngP",
  "onHoverText": "qLjSF",
  "hideBlock": "zmnfi",
  "smallBlur": "SzNgO",
  "mediumBlur": "_33Yuj",
  "largeBlur": "_3lKrl",
  "hideBlock_gallery": "q4-7-",
  "overlay": "qegyW",
  "overlay_gallery": "mAzJg",
  "revealSpoilerBtn": "gS5j2",
  "isMobile": "FDVuS",
  "onHoverBtn": "XxK7Z",
  "spoilerWrapper": "rpJzx",
  "spoilerDescription": "X6eaX",
  "spoilerContainer": "IaeH0",
  "spoilerContainer_Gallery": "-ixDe"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
